import { render } from "./MainInsuranceAccountsReceivable.vue?vue&type=template&id=1288e0d2&scoped=true"
import script from "./MainInsuranceAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./MainInsuranceAccountsReceivable.vue?vue&type=script&lang=js"

import "./MainInsuranceAccountsReceivable.vue?vue&type=style&index=0&id=1288e0d2&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1288e0d2"]])

export default __exports__